module.exports = __webpack_public_path__ + "static/img/loading1.4b408a5.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/loading1.gif
// module id = xe9v
// module chunks = 1